/**
 * 로그인된 사용자가 공개 라우트(로그인·가입)에서 되돌아갈 자리 — 선언 한 곳.
 * 보호 라우트(ProtectedRoute)가 미인증 사용자를 /login 으로 보낼 때 `state.from` 에 남긴 위치를 읽는다.
 */

/** 남긴 자리가 없을 때의 목적지 — /home 은 라우터가 랜딩(/)으로 승계한다 */
export const AFTER_LOGIN_FALLBACK_PATH = '/home';

/** 되돌아갈 자리는 이 앱 안의 경로뿐 — 문자열이고 `/` 로 시작하며 `//host` 꼴(스킴 상대 주소)이 아니어야 한다 */
const isInAppPath = (pathname: unknown): pathname is string =>
  typeof pathname === 'string' && pathname.startsWith('/') && !pathname.startsWith('//');

/** `state.from`(경로·질의·해시)을 되돌아갈 주소로 — pathname 이 없거나 앱 안의 경로가 아니면 기본 목적지 */
export function returnPathOf(state: unknown): string {
  const from = (state as { from?: { pathname?: unknown; search?: string; hash?: string } } | null)?.from;
  const pathname = from?.pathname;
  if (!from || !isInAppPath(pathname)) return AFTER_LOGIN_FALLBACK_PATH;
  return `${pathname}${from.search ?? ''}${from.hash ?? ''}`;
}
